module.exports = __webpack_public_path__ + "assets/img/banner5.017a6c76.png";